jQuery($ => {
    class BracesColorsTabber {
        constructor(element) {
            this._        = element;
            this._element = $(element);
            this._tabs    = this._element.find('.o-braces-colors-tabber__tab-item');
            this._select  = this._element.find('.o-braces-colors-tabber__select');

            this.init();
        }

        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
        // ✅ Initialize
        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

        init() {
            this.setupHandlers();
            this._element.trigger( 'init', this );
        }

        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
        // ✅ Setup Handlers
        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

        setupHandlers() {
            this._tabs.each((_, tab) => {
                $(tab).on('mousedown', event => {
                    this.handleTabMousedown(event, tab);
                });

                $(tab).on('keydown', event => {
                    this.handleTabKeydown(event, tab);
                });
            });

            this._select.on('change', function(){
                var item      = $(this).find('.a-select__item--selected'),
                    controlID = item.data('value');

                $('.o-braces-colors-tabber__tab-panel').removeClass('o-braces-colors-tabber__tab-panel--active');
                $('.o-braces-colors-tabber__tab-panel[id="' + controlID + '"]').addClass('o-braces-colors-tabber__tab-panel--active');
            });
        }


        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
        // ✅ Handle Tab Select
        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

        handleTabSelect = tab => {
            $(tab).addClass('o-braces-colors-tabber__tab-item--active');
            var controlID = $(tab).attr('aria-controls');

            $('.o-braces-colors-tabber__tab-panel').removeClass('o-braces-colors-tabber__tab-panel--active');
            $('.o-braces-colors-tabber__tab-panel[id="' + controlID + '"]').addClass('o-braces-colors-tabber__tab-panel--active');
        }

        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
        // ✅ Handle Tab Deselect
        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

        handleTabDeselect = tab => {
            $(tab).removeClass('o-braces-colors-tabber__tab-item--active')
        }

        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
        // ✅ Handle Tab Click
        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

        handleTabMousedown = (event, tab) => {
            event.preventDefault();

            this.handleTabSelect(tab);

            this._tabs.not(tab).each((_, _tab) => this.handleTabDeselect(_tab));
        }

        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
        // ✅ Handle Tab Keydown
        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

        handleTabKeydown = (event, tab) => {
            switch (event.key) {
                case "Enter":
                case "spacebar":
                case " ":
                    if (!this._isAutomatic) {
                        event.preventDefault();

                        this.handleTabSelect(tab);

                        this._tabs.not(tab).each((_, _tab) => this.handleTabDeselect(_tab));
                    }
                    break;

                case 'ArrowLeft':
                case 'ArrowUp':
                    event.preventDefault();

                    const $prevItem = $(tab)
                        .closest('.o-braces-colors-tabber__item')
                        .prev();

                    if ($prevItem[0]) {
                        const $prevTab = $prevItem.find('.o-braces-colors-tabber__tab');

                        $prevTab.focus();

                        if (this._isAutomatic) {
                            this.handleTabSelect($prevTab);
                            this._tabs.not($prevTab).each((_, _tab) => this.handleTabDeselect(_tab));
                        }
                    }
                    break;

                case 'ArrowRight':
                case 'ArrowDown':
                    event.preventDefault();

                    const $nextItem = $(tab)
                        .closest('.o-braces-colors-tabber__item')
                        .next();

                    if ($nextItem[0]) {
                        const $nextTab = $nextItem.find('.o-braces-colors-tabber__tab');

                        $nextTab.focus();

                        if (this._isAutomatic) {
                            this.handleTabSelect($nextTab);
                            this._tabs.not($nextTab).each((_, _tab) => this.handleTabDeselect(_tab));
                        }
                    }
                    break;

                case "Home":
                    event.preventDefault();

                    const $firstTab = this._list
                        .find(".o-braces-colors-tabber__item")
                        .first()
                        .find(".o-braces-colors-tabber__tab");

                    $firstTab.focus();

                    if (this._isAutomatic) {
                        this.handleTabSelect($firstTab);
                        this._tabs.not($firstTab).each((_, _tab) => this.handleTabDeselect(_tab));
                    }
                    break;

                case "End":
                    event.preventDefault();

                    const $lastTab = this._list
                        .find(".o-braces-colors-tabber__item")
                        .last()
                        .find(".o-braces-colors-tabber__tab");

                    $lastTab.focus();

                    if (this._isAutomatic) {
                        this.handleTabSelect($lastTab);
                        this._tabs.not($lastTab).each((_, _tab) => this.handleTabDeselect(_tab));
                    }
                    break;
            }
        }

    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup jQuery Plugin
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    $.fn.braces_colors_tabber = function() {
        var _ = this,
                opt = arguments[0],
                args = Array.prototype.slice.call(arguments, 1),
                l = _.length,
                i,
                ret;
        for (i = 0; i < l; i++) {
            if (typeof opt == 'object' || typeof opt == 'undefined')
                _[i].braces_colors_tabber = new BracesColorsTabber(_[i], opt);
            else
                ret = _[i].braces_colors_tabber[opt].apply(_[i].braces_colors_tabber, args);
            if (typeof ret != 'undefined') return ret;
        }
        return _;
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Run
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    $('.o-braces-colors-tabber').braces_colors_tabber();
});